module.exports = __webpack_public_path__ + "img/home-main.dfe281b3.jpg";